import { BondNumberSelectBase } from "../../components/BondNumberSelectBase";

export const BondNumberSelect = (props) => (
  <BondNumberSelectBase surface="historic" {...props} />
);
